import { render, staticRenderFns } from "./MentionsView.vue?vue&type=template&id=047732b4&scoped=true"
import script from "./MentionsView.vue?vue&type=script&lang=js"
export * from "./MentionsView.vue?vue&type=script&lang=js"
import style0 from "./MentionsView.vue?vue&type=style&index=0&id=047732b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047732b4",
  null
  
)

export default component.exports